import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { Vendedor } from 'src/app/aplicaciones-modulos/vdi/vendedor/model/vendedor';

@Component({
  selector: 'app-promocion-vendedores',
  templateUrl: './promocion-vendedores.component.html',
  styleUrls: ['./promocion-vendedores.component.css']
})
export class PromocionVendedoresComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsCondVendedor = [];
  frameworkComponents: any;
  rowDataCondVendedor: any[] = [];
  verFormularioAgregarCondVendedor = false;

  idPromo: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarCondVendedor(id);
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsCondVendedor = [
      {
        headerName: 'Vendedor',
        field: 'id_vendedor',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Nombre',
        field: 'name_vendedor',
        sortable: true,
        filter: true
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.eliminarCondVendedor.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block'
        },
      },
    ];
  }

  cargarCondVendedor(id_promo) {
    this.promocionesService.cargarCondVendedor(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataCondVendedor = resp;
        } else {
          this.rowDataCondVendedor = [];
        }
      },
      (error) => {
        this.rowDataCondVendedor = [];
      }
    );
  }

  nuevoCondVendedor() {
    this.verFormularioAgregarCondVendedor = true;
  }

  back() {
    this.verFormularioAgregarCondVendedor = false;
  }

  eliminarCondVendedor({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        action: 'Eliminar',
        funcion: this.promocionesService.borrarCondVendedor(rowData),
      })
      .then((res: any) => {
        this.cargarCondVendedor(this.idPromo);
      });
  }

  guardarCondVendedor(vendedores: Vendedor[]) {
    const body = vendedores.map((vendedor) => ({
      id_promo: this.idPromo,
      id_vendedor: vendedor.id
    }));

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: 'Nuevo',
        funcion: this.promocionesService.crearCondVendedorLista(body),
      })
      .then((res: any) => {
        this.cargarCondVendedor(this.idPromo);
        this.verFormularioAgregarCondVendedor = false;
      });
  }

}
